import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { ROUTES } from "./sidebar-items";
import { AuthService } from "src/app/core/service/auth.service";
import { Role } from "src/app/core/models/role";

const document: any = window.document;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  userImg: string;
  userType: string;
  headerHeight = 60;
  currentRoute: string;
  routerObj = null;
  selectedIndex: number;
  selectedIndex1: number;
  selectedIndex2: number;
  private hasAutoClicked = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authService: AuthService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    const body = this.elementRef.nativeElement.closest("body");
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, "overlay-open");
      }
    });
    this.authService.menuListSubject.subscribe((res) => {
      // console.log("sidebar");
      this.ngOnInit();
    });

    this.activeSubModule();
  }
  ngAfterViewInit(): void {
    console.log("ngAfterViewInit")
    // Wait until Angular finishes DOM rendering completely
    if (this.router.url.includes('/coremodule/Dashboard')) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.autoClickFirstMenu();
          });
        }, 1000); // wait 500ms to ensure the sidebar template is in DOM
      });
    }
  }
  autoClickFirstMenu() {
    setTimeout(() => {
      const firstMainMenu = document.querySelector('.list li a.menu-top') as HTMLElement;
      if (firstMainMenu) {
        const currentUrl = this.router.url;
        const menuHref = firstMainMenu.getAttribute('href') || '';

        // avoid clicking if it navigates to current route
        if (!menuHref || currentUrl.includes(menuHref)) {
          console.log('ℹ️ Skipping click — already on the target route.');
          return;
        }

        firstMainMenu.click();
        console.log('✅ First main menu clicked:', firstMainMenu.innerText);

        setTimeout(() => {
          const firstSubMenu = document.querySelector('.list li ul.ml-menu li a') as HTMLElement;
          if (firstSubMenu) firstSubMenu.click();
        }, 400);
      }
    }, 200);
  }



  activeSubModule() {
    if (localStorage.getItem('module') != '') {
      this.selectedIndex = parseInt(localStorage.getItem('module'));
      if (localStorage.getItem('submodule') != '') {
        this.selectedIndex1 = parseInt(localStorage.getItem('submodule'));
        if (localStorage.getItem('subsubModule') != '') {
          this.selectedIndex2 = parseInt(localStorage.getItem('subsubModule'));
        }
      }
    }
  }

  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  select(event: any, index: number) {
    event.stopPropagation();
    this.selectedIndex = index;
    this.selectedIndex1 = null;
    this.selectedIndex2 = null;
    if (index != parseInt(localStorage.getItem('module'))) {
      localStorage.setItem("module", index.toString());
      localStorage.setItem("submodule", '');
      localStorage.setItem("subsubModule", '');
      this.authService.setModule(JSON.parse(localStorage.getItem('menuList')));

    }
    this.authService.setSubmodule([]);
    console.log("module>>", index);
    this.authService.setHideNavBar(true);
    const parentElement = event.target.closest("li");
    const activeClass = parentElement.classList.contains("active");

    if (activeClass) {
      this.renderer.removeClass(parentElement, "active");
    } else {
      this.renderer.addClass(parentElement, "active");
    }
  }
  select1(event: any, index: number, menu?: any) {
    event.stopPropagation();
    localStorage.setItem("submodule", index.toString());
    let menuList = [];
    JSON.parse(localStorage.getItem('menuList')).forEach(element => {
      if (element.moduleId === parseInt(localStorage.getItem('module'))) {
        menuList = element.submenu;
      }
    });
    this.authService.setSubmodule(menuList[index]['submenu']);
    // this.authService.setModule(JSON.parse(localStorage.getItem('menuList')));
    console.log("submodule>>", index)
    this.selectedIndex1 = index;
    this.selectedIndex2 = null;
    this.router.navigate(["/admin/dashboar-module"]);
    if (menu.path != '' && menu.path === '/admin/dashboar-module') {
      this.authService.setHideNavBar(true);
    } else {
      this.authService.setHideNavBar(false);
    }
  }
  select2(event: any, index: number) {
    event.stopPropagation();
    localStorage.setItem("subsubModule", index.toString());
    console.log("subsubModule>>", index)
    this.selectedIndex2 = index;
  }

  callToggleMenu(event: any, length: any, menu?: any) {
    console.log('🔵 callToggleMenu called with menu.title:', menu?.title);
    this.authService.setHeaderMenuList([]);
    console.log("menu title ",menu.title)
    if (menu.path != '' && menu.path === '/admin/dashboar-module') {
      this.authService.setHideNavBar(true);
    } else {
      this.authService.setHideNavBar(false);
    }
    localStorage.setItem("menu", JSON.stringify(menu));
    
    // Check if menu is MRD with empty submenu - should fetch from API
    if (menu.title === 'MRD' && (!menu.submenu || menu.submenu.length === 0)) {
      console.log('🟡 MRD has empty submenu, fetching from API...');
      this.authService.getMenuList(menu?.submoduleId, menu?.moduleId);
      localStorage.setItem("moduleId", menu?.moduleId);
      localStorage.setItem("subModuleId", menu?.submoduleId);
      return; // Exit early, let API handle it
    }
    
    if (menu.title != 'Financial Accounting' && menu.title != 'Cost Accounting' && menu.title != 'MRD Transit Reports' && menu.title != 'MRD') {
      this.authService.getMenuList(menu?.submoduleId, menu?.moduleId);
    } else {
      if (menu.title === 'Financial Accounting' || menu.title === 'Cost Accounting') {
        let menuList = [];
        JSON.parse(localStorage.getItem('menuList')).forEach(element => {
          if (element.moduleId === parseInt(localStorage.getItem('module'))) {
            menuList = element.submenu;
          }
        });
        const accountingMenus = menuList.filter(item => item.title === "Accounting");
        const accountingSubmenu = accountingMenus[0].submenu.filter(item => item.title === menu.title);
        const submenus = accountingSubmenu.map(item => item.submenu);
        console.log(submenus);
        this.authService.setSubmodule(submenus[0]);
        this.router.navigate(["/admin/dashboar-module"]);
        console.log("menuList", JSON.stringify(accountingMenus[0].submenu))
      } else if (menu.title === 'MRD Transit Reports') {
        let menuList = [];
        JSON.parse(localStorage.getItem('menuList')).forEach(element => {
          if (element.moduleId === parseInt(localStorage.getItem('module'))) {
            menuList = element.submenu;
          }
        });
        const accountingMenus = menuList.filter(item => item.title === "Patients Care");
        const accountingSubmenu = accountingMenus[0].submenu.filter(item => item.title === menu.title);
        const submenus = accountingSubmenu.map(item => item.submenu);
        console.log(submenus);
        this.authService.setSubmodule(submenus[0]);
        this.router.navigate(["/admin/dashboar-module"]);
        console.log("menuList", JSON.stringify(accountingMenus[0].submenu))
      } else if (menu.title === 'MRD') {
        console.log('=== MRD Menu Clicked ===');
        console.log('Menu object:', menu);
        
        let menuList = [];
        JSON.parse(localStorage.getItem('menuList')).forEach(element => {
          if (element.moduleId === parseInt(localStorage.getItem('module'))) {
            menuList = element.submenu;
          }
        });
        
        console.log('Full menuList from localStorage:', menuList);
        console.log('Looking for Patients Care in menuList...');
        
        const patientsCareMenus = menuList.filter(item => item.title === "Patients Care");
        console.log('Patients Care menus found:', patientsCareMenus);
        
        if (patientsCareMenus && patientsCareMenus.length > 0) {
          console.log('Patients Care submenu:', patientsCareMenus[0].submenu);
          
          const mrdSubmenu = patientsCareMenus[0].submenu.filter(item => item.title === menu.title);
          console.log('MRD submenu filtered:', mrdSubmenu);
          
          if (mrdSubmenu && mrdSubmenu.length > 0) {
            const submenus = mrdSubmenu.map(item => item.submenu);
            console.log('MRD submenus extracted:', submenus);
            console.log('Setting submodule to:', submenus[0]);
            
            this.authService.setSubmodule(submenus[0]);
            this.router.navigate(["/admin/dashboar-module"]);
            console.log("MRD menuList", JSON.stringify(patientsCareMenus[0].submenu));
          } else {
            console.error('❌ MRD submenu not found in Patients Care submenu!');
            console.log('Available submenu titles:', patientsCareMenus[0].submenu.map(s => s.title));
          }
        } else {
          console.error('❌ Patients Care menu not found in menuList!');
          console.log('Available menu titles:', menuList.map(m => m.title));
        }
        console.log('=== End MRD Debug ===');
      }

      // this.authService.setSubmodule(menuList[index]['submenu']);
    }
    // 
    localStorage.setItem("moduleId", menu?.moduleId);
    localStorage.setItem("subModuleId", menu?.submoduleId);
    if (length > 0) {
      const parentElement = event.target.closest("li");
      const activeClass = parentElement.classList.contains("active");

      if (activeClass) {
        this.renderer.removeClass(parentElement, "active");
      } else {
        this.renderer.addClass(parentElement, "active");
      }
    }
  }
  ngOnInit() {
    if (this.authService.currentUserValue) {
      // const userRole = this.authService.currentUserValue.role;
      const userRole = 'Admin';
      this.userFullName =
        this.authService.currentUserValue.userFullName;
      // this.userImg = this.authService.currentUserValue.img;
      // console.log(this.userFullName);
      let menuList = [];
      menuList.push(ROUTES[0]);
      console.log(this.authService.menuList);
      this.authService.menuList?.forEach(element => {
        menuList.push(element);
      });
      this.sidebarItems = menuList.filter(
        (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf("All") !== -1
      );
      // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
      // this.sidebarItems = JSON.parse(localStorage.getItem('menuList')).filter(
      //     (x) => x.role.indexOf(userRole) !== -1 || x.role.indexOf("All") !== -1
      //   );

      if (userRole === Role.Admin) {
        this.userType = Role.Admin;
      } else if (userRole === Role.Patient) {
        this.userType = Role.Patient;
      } else if (userRole === Role.Doctor) {
        this.userType = Role.Doctor;
      } else {
        this.userType = Role.Admin;
      }
    }

    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.activeSubModule();
    this.bodyTag = this.document.body;
    // this.callToggleMenu(null,null,JSON.parse(localStorage.getItem("menu")));
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  logout() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
    this.authService.logintracker({ "loginTrackId": localStorage.getItem('loginTrackId'), "btn_name": "LOGOUT" }).subscribe((response) => {
    })
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(["/authentication/signin"]);
      }
    });
  }


}
